import { render } from "./FlexibleInput.vue?vue&type=template&id=dc8d6420&scoped=true"
import script from "./FlexibleInput.vue?vue&type=script&lang=js"
export * from "./FlexibleInput.vue?vue&type=script&lang=js"

import "./FlexibleInput.vue?vue&type=style&index=0&id=dc8d6420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8d6420"]])

export default __exports__